import React from "react";
import ScrollToTop from "./ScrollToTop";
import wzLogo from "../../resources/images/wz.png";


const Footer = () => {

    return (
    <>
        <footer className="wz-app-footer" aria-label="Application footer">
            <img src={wzLogo} alt="Warehouse Zone Ltd" className="wz-app-footer__logo" />
            <span>
                Developed and maintained by{" "}
                <a href="https://warehousezone.co.uk" target="_blank" rel="noopener noreferrer">
                    Warehouse Zone Ltd (WMS Suite)
                </a>
            </span>
        </footer>
        <ScrollToTop />
    </>);
}

export default Footer;
